"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.managementInformation = void 0;
var submittedStageOne_1 = require("./managementInformation/submittedStageOne");
var submittedStageTwo_1 = require("./managementInformation/submittedStageTwo");
var submittedStageFour_1 = require("./managementInformation/submittedStageFour");
var proposedStageOne_1 = require("./managementInformation/proposedStageOne");
var proposedStageTwo_1 = require("./managementInformation/proposedStageTwo");
var proposedStageFour_1 = require("./managementInformation/proposedStageFour");
var submittedStageThree_1 = require("./managementInformation/submittedStageThree");
var proposedStageThree_1 = require("./managementInformation/proposedStageThree");
var Joi = require('joi').extend(require('@joi/date'));
exports.managementInformation = Joi.object({
    causeOfDefault: Joi.string()
        .min(0)
        .max(100)
        .required(),
    dateHardshipBegan: Joi.date()
        .max('12-31-9999')
        .required(),
    description: Joi.string()
        .min(0)
        .max(1000)
        .required(),
    lenderAcknowledgementAdditionalDetails: Joi.string()
        .min(0)
        .max(1000)
        .options({ convert: false })
        .when('preApprovalRequired', {
        is: true,
        then: Joi.string().required(),
    })
        .when('preApprovalRequired', {
        is: false,
        then: Joi.string()
            .strip()
            .optional()
            .allow('', null),
    }),
    lenderAcknowledgementSignatureFullName: Joi.string()
        .min(0)
        .max(35)
        .required(),
    lenderAcknowledgementSignatureTitle: Joi.string()
        .min(0)
        .max(50)
        .required(),
    monitoringStrategy: Joi.string()
        .min(0)
        .max(1000)
        .required(),
    preApprovalRequired: Joi.boolean().required(),
    proposedDefaultStage: Joi.number()
        .min(0)
        .integer()
        .max(9999)
        .options({ convert: false })
        .optional(),
    submittedDefaultStage: Joi.number()
        .min(0)
        .integer()
        .max(9999)
        .options({ convert: false })
        .required(),
    submittedStageOne: submittedStageOne_1.submittedStageOne,
    submittedStageTwo: submittedStageTwo_1.submittedStageTwo,
    submittedStageFour: submittedStageFour_1.submittedStageFour,
    proposedStageOne: proposedStageOne_1.proposedStageOne,
    proposedStageTwo: proposedStageTwo_1.proposedStageTwo,
    proposedStageFour: proposedStageFour_1.proposedStageFour,
    submittedStageThree: submittedStageThree_1.submittedStageThree,
    proposedStageThree: proposedStageThree_1.proposedStageThree,
});
exports.default = { managementInformation: exports.managementInformation };
